import React from 'react';
import { Box, Card, CardContent, Stack, Typography } from '@mui/material';
import { Business as BusinessIcon } from '@mui/icons-material';

interface AvgDaysToRespondCardProps {
  value: number;
}

const AvgDaysToRespondCard: React.FC<AvgDaysToRespondCardProps> = ({ value }) => {
  return (
    <Card sx={{ border: '1px solid #e2e8f0', flex: 1, minWidth: { xs: '100%', sm: 'calc(50% - 8px)', lg: 'auto' } }}>
      <CardContent>
        <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
          <Box>
            <Typography variant="body2" sx={{ color: '#64748b', mb: 1 }}>
              Avg Days to Respond
            </Typography>
            <Typography variant="h4" sx={{ fontWeight: 600, color: '#1e293b' }}>
              {value.toFixed(1)}
            </Typography>
          </Box>
          <Box
            sx={{
              backgroundColor: '#10b98115',
              borderRadius: '50%',
              p: 1,
              display: 'flex',
            }}
          >
            <BusinessIcon sx={{ color: '#10b981' }} />
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default AvgDaysToRespondCard;
